import { ArrowUpRight, Eye, HeartHandshake } from "lucide-react";
import { problemCards } from "@/content";
import { Reveal } from "@/components/Reveal";

export default function EmpathySection() {
  return (
    <section className="section empathy-section" id="sobre-o-livro" data-testid="empathy-section">
      <div className="section-shell empathy-grid">
        <Reveal className="section-intro">
          <p className="eyebrow">ANTES DE QUALQUER MÉTODO</p>
          <h2>Você não é um saldo negativo. Você é uma pessoa atravessando um ciclo.</h2>
          <p>As plataformas são desenhadas para manter atenção, urgência e esperança artificial em movimento. Reconhecer isso não tira sua responsabilidade — devolve a você um ponto de partida honesto.</p>
          <a href="#capitulos" className="inline-link" data-testid="empathy-chapters-link">Conhecer o caminho <ArrowUpRight size={16} /></a>
        </Reveal>
        <div className="problem-notes">
          {problemCards.map((item, index) => (
            <Reveal key={item.title} delay={index * 80}>
              <article className="problem-note" data-testid={`problem-card-${index + 1}`}>
                <span className="note-icon">{index === 0 ? <Eye size={18} /> : index === 1 ? <HeartHandshake size={18} /> : <span>0{index + 1}</span>}</span>
                <div><h3>{item.title}</h3><p>{item.description}</p><blockquote>{item.verse}</blockquote></div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
